<template>
  <div class="arrival-wrap" @click="$emit('closed')">
    <transition name="gift">
      <div class="content" v-if="isShowContent">
        <div class="txt">{{ $t('txt_congrats') }}</div>
        <div class="gifts" :class="options.type"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  name: 'ArrivalPanel',
  mixins: [mixins],
  props: {
    options: {
      type: Object,
      default: () => ({
        type: ''
      })
    }
  },
  data () {
    return {
      isShowContent: false
    }
  },
  methods: {
    startShow () {
      this.isShowContent = true
    }
  }
}
</script>

<style lang='scss' scoped >
.gift-enter-active, .gift-leave-active {
  transition: all .5s;
}
.gift-enter, .gift-leave-to {
  opacity: 0;
  transform: scale(0);
}
.arrival-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    transform-origin: center top;
    padding-top: calc(135 / 1920 * 100vw);
    width: 100vw;
    height: calc(745 / 1920 * 100vw);
    background: url(~@/assets/img/bg_arrival.png) no-repeat center center;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .txt {
    text-align: center;
    font-size: calc(54 * var(--unit-px));
    font-weight: bold;
    color: #FFE05B;
    line-height: 1.4;
    text-shadow: 0px 1px 2px #000000;
  }
  .gifts {
    width: 100%;
    height: calc(162 * var(--unit-px));
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: calc(69 * var(--unit-px));
    &.bind {
      background-image: url(~@/assets/img/arrival_gift_bind.png);
    }
    &.pwa {
      background-image: url(~@/assets/img/arrival_gift_pwa.png);
    }
  }
}
</style>
